<template>
    <v-container>
      <v-form ref="form" v-model="formValid" lazy-validation>
        <!-- Pilih Surveyor -->
        <v-select
          v-model="form.user_id"
          :items="users"
          item-text="nama"
          item-value="id"
          label="Pilih Surveyor"
          :rules="[rules.required]"
          required
        ></v-select>
  
        <!-- Tombol Simpan: full width + Bootstrap 4 style -->
        <v-btn
          class="btn btn-primary mt-2"
          block
          @click="submitForm"
          :disabled="!formValid || loading"
        >
          {{ loading ? 'Menyimpan...' : 'Simpan' }}
        </v-btn>
      </v-form>
    </v-container>
  </template>
  
  <script>
  import { EventBus } from './../../event-bus'
  export default {
    props: {
        id: {
            type: [Number, String],
            required: true
        }
    },
    data() {
      return {
        formValid: false,
        loading: false,
        form: {
          user_id: null
        },
        users: [],
        rules: {
          required: v => !!v || 'Wajib diisi'
        }
      };
    },
    mounted() {
      this.fetchUsers();
    },
    methods: {
      // Ambil data user dari API
      async fetchUsers() {
        try {
          const res = await axios.get('api/sales/list_surveyor');
          this.users = res.data.data;
        } catch (err) {
          console.error('Gagal memuat users:', err);
        }
      },
  
      // Submit form ke API
      async submitForm() {
        if (this.$refs.form.validate()) {
          this.loading = true;
          try {
            const data = await axios.post(`api/pelanggan/surveyor/${this.id}`, this.form);
            Toast.fire({
                icon: 'success',
                title: data.data.message
            });
            this.$refs.form.reset();
            this.$refs.form.resetValidation();
            EventBus.$emit('pelanggan:updated');
            EventBus.$emit('modal:close');
          } catch (err) {
            console.error('Gagal menyimpan:', err);
          } finally {
            this.loading = false;
          }
        }
      }
    }
  };
  </script>
  